// extracted by mini-css-extract-plugin
export default {"ulWrapper":"styles_ulWrapper__IQKai"};